import {register} from "@shopify/theme-sections"
import $ from "jquery"
import '../../styles/sections/custom-images.scss'

export default register(`custom-images`, {
    onLoad() {
        $(`.custom-images-slider`).slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        })
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
        $(`.custom-images-slider`).unslick()
    },
})
